import HTTP from '../common/http-common';

const END_POINT = '/car';

const existCar = (licenseNo, modelCode, branchCode) => HTTP.get(END_POINT + "/exists-car", {
    params: {
        branchCode: branchCode,
        licenseNo: licenseNo,
        modelCode: modelCode
    }
});

const listCar = () => HTTP.get(END_POINT);

const insertCar = (data) => HTTP.post(END_POINT, {
    licenseNo: data.licenseNo,
    licenseNoProvince: data.licenseNoProvince,
    bodyNumber: data.bodyNumber,
    engineNumber: data.engineNumber,
    modelCode: data.modelCode,
    bodyType: data.bodyType,
    colorCode: data.colorCode,
    branchCode: data.branchCode,
    brandCode: data.brandCode
});
const updateCar = (data) => HTTP.post(END_POINT + "/" + data.carId, {
    licenseNo: data.licenseNo,
    licenseNoProvince: data.licenseNoProvince,
    bodyNumber: data.bodyNumber,
    engineNumber: data.engineNumber,
    modelCode: data.modelCode,
    bodyType: data.bodyType,
    colorCode: data.colorCode,
    branchCode: data.branchCode,
    brandCode: data.brandCode
});

const deleteCar = (carId) => HTTP.delete(END_POINT + "/" + carId);

export {
    listCar,
    insertCar,
    updateCar,
    deleteCar,
    existCar
}